import { atomWithStorage } from "jotai/utils";
import { atom } from "jotai";

export const locationAtom = atomWithStorage("currentLocation", {
  lat: "31.4804642",
  lng: "74.3239342",
});
export const loggedInUser = atomWithStorage("loggedUser", {});
export const mobileViewCheck = atomWithStorage("mobileView", false);
export const teamIDCheck = atomWithStorage("userTeamId", null);
export const userIDCheck = atomWithStorage("userID", null);

export const accountType = atomWithStorage("personalAccount", true);

export const subscriptionPackages = atomWithStorage("purchasePackages", []);

// Helper to get initial value from localStorage, never returning empty object if data exists
const getInitialPackageValue = (key) => {
  try {
    const stored = localStorage.getItem(key);
    console.log(`[Store Init] Reading ${key} from localStorage:`, stored);
    if (stored && stored !== "null" && stored !== "undefined" && stored !== "{}") {
      const parsed = JSON.parse(stored);
      if (parsed && Object.keys(parsed).length > 0) {
        console.log(`[Store Init] ${key} has valid data:`, parsed);
        return parsed;
      }
    }
  } catch (e) {
    console.error(`[Store Init] Error reading ${key} from localStorage:`, e);
  }
  console.log(`[Store Init] ${key} returning empty default`);
  return {};
};

export const subscribedPackage = atomWithStorage(
  "purchasedPackage", 
  getInitialPackageValue("purchasedPackage")
);

export const teamSubscribedPackage = atomWithStorage(
  "teamPurchasedPackage",
  getInitialPackageValue("teamPurchasedPackage")
);

export const isOwnerPackage = atomWithStorage("isOwnerPackageActive", false);
export const isPersonalPackage = atomWithStorage(
  "isPersonalPackageActive",
  false
);
export const userRemainingFunctions = atomWithStorage(
  "userAvailableFunctions",
  {
    total_cards: 0,
    total_connections: 0,
    total_payments: 0,
    total_emergency_contacts: 0,
    total_custom_urls: 0,
    total_file_uploads: 0,
    total_form_builders: 0,
    total_memory: 0,
    total_medical_id: 0,
    total_dynamic_qr_codes: 0,
  }
);
export const memberRemainingFunctions = atomWithStorage(
  "memberAvailableFunctions",
  {
    total_cards: 0,
    total_connections: 0,
    total_payments: 0,
    total_emergency_contacts: 0,
    total_custom_urls: 0,
    total_file_uploads: 0,
    total_form_builders: 0,
    total_memory: 0,
    total_medical_id: 0,
    total_dynamic_qr_codes: 0,
  }
);
export const userRemainingFunctionsForDynamicQR = atomWithStorage(
  "userAvailableFunctionsForDynamicQR",
  []
);
export const globalAppSetting = atomWithStorage("appSetting", {});

export const globalLoading = atom(false);

export const apiCounts = atomWithStorage("apiCountsFunction", {});

export const themeColorAtom = atomWithStorage("themeColor", null);
export const buttonColorAtom = atomWithStorage("buttonColor", null);
export const teamLogoAtom = atomWithStorage("teamLogoUrl", "");
